/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./common-hot-xlz.vue?vue&type=template&id=a6330844&scoped=true&"
import script from "./common-hot-xlz.vue?vue&type=script&lang=ts&"
export * from "./common-hot-xlz.vue?vue&type=script&lang=ts&"
import style0 from "./common-hot-xlz.vue?vue&type=style&index=0&id=a6330844&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6330844",
  null
  
)

export default component.exports